<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <v-container
    v-if="isAuthenticated && isServerInitialized && hasAlerts"
    fluid
    class="alerts-container px-3"
  >
    <v-alert
      v-if="alerts"
      border="start"
      variant="outlined"
      class="alert"
      icon="icon-Error-notification"
      type="error"
    >
      <span v-for="item in alerts" :key="item.errorCode" class="alert-text">
        {{ $t(item.errorCode, reformatDates(item.metadata)) }}
      </span>
    </v-alert>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { formatDateTime, formatDateTimeSeconds } from '@/filters';
import { mapState } from 'pinia';
import { useAlerts } from '@/store/modules/alerts';
import { useUser } from '@/store/modules/user';
import { useSystem } from '@/store/modules/system';

export default defineComponent({
  name: 'AlertsContainer',
  computed: {
    ...mapState(useAlerts, ['alerts']),
    ...mapState(useUser, ['isAuthenticated']),
    ...mapState(useSystem, ['isServerInitialized']),
    hasAlerts(): boolean {
      return this.alerts?.length > 0;
    },
  },
  methods: {
    formatDateTime,
    reformatDates(metadata?: string[]): string[] {
      return (metadata || []).map((item) => {
        if (isNaN(Date.parse(item))) {
          return item;
        }
        return formatDateTimeSeconds(item);
      });
    },
  },
});
</script>

<style scoped lang="scss">
@use '@niis/shared-ui/src/assets/colors';

.alerts-container {
  padding: 0;

  & > * {
    margin-bottom: 4px;
    border-radius: 0;
  }

  & > :first-child {
    margin-top: 16px;
  }
}

.alert {
  margin-top: 16px;
  border: 2px solid colors.$WarmGrey30;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: colors.$White100;
}

.alert-text {
  color: colors.$Black100;
  display: block;
}
</style>
